import React from 'react'
import { Box, Stack, Checkbox, Typography } from '@mui/material'


export const GalleryFormFieldLabel = ({ label }) => {

  const labelStyling = {
    width: 130,
    fontWeight: 600,
    fontSize: 12,
    color: '#606060',
    display: 'flex',
    alignItems: 'center'
  }
  
  return (
    <Typography sx={labelStyling}>
      {label}:
    </Typography>
  )
}
